<template>
  <div class="five_snail_anniversary_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'六周年纪念章'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
      name="fade"
    >
      <div
        @touchmove.prevent
        class="preloading preloading-snail"
        v-show="preloadingShow"
      ></div>
    </transition>

    <!-- 活动未开始 -->
    <div :class="'none ' + isWhite"></div>

    <div class="five-snail-anniversary-content">
      <div class="swiper-container" ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide slide-page-container">
            <div class="top-container">
              <div class="big-title"></div>
              <!-- 动态发售文案标题 -->
              <div v-if="rightTitleClass" :class="rightTitleClass"></div>
              <div></div>
            </div>

            <div class="anniversary-swiper-box popup_wrap-box">
              <div class="swiper-container-2">
                <div class="slide-box">
                  <img
                    :key="currentIndex"
                    :src="swiperList[currentIndex].photo"
                    @click="showImage(swiperList[currentIndex].photo)"
                  />
                </div>

                <div class="next-btn" @click="nextImage"></div>
              </div>

              <div class="star_1"></div>
              <div class="star_2"></div>
              <div class="star_3"></div>
              <div class="tip_text" v-if="actual_quantity"></div>
            </div>

            <div class="role-container"></div>

            <div class="rule-box">
              <a
                href="javascript:;"
                class="rule-btn"
                @click="ruleShow = true"
              ></a>
            </div>

            <div class="aniv-box">
              <a
                href="javascript:;"
                class="aniv-btn"
                @click="goAnniversary"
              ></a>
            </div>

            <!-- 奖励容器 统一处理 -->
            <div
              :class="
                rewardPanelType === 3
                  ? 'reward-container_3'
                  : 'reward-container_2'
              "
            >
              <div class="reward-box">
                <div @click="openPayDialog(3)" class="left-box">
                  <i v-if="firstNoClick"></i>
                </div>
                <div class="first-light"></div>

                <div @click="openPayDialog(1)" class="center-box">
                  <i v-if="secondNoClick"></i>
                </div>
                <div class="second-light"></div>
                <div class="second-star"></div>

                <template v-if="rewardPanelType === 3">
                  <div @click="openPayDialog(2)" class="right-box">
                    <i v-if="thirdNoClick"></i>
                  </div>
                  <div class="third-light"></div>
                  <div class="third_star_1"></div>
                  <div class="third_star_2"></div>
                  <div class="light-bg"></div>
                </template>
              </div>
            </div>

            <div class="btn-box">
              <div class="top-box">
                <!-- 福利礼包 (始终显示) -->
                <a
                  v-if="canBuy"
                  @click="openPayDialog(3)"
                  :class="btnClasses.welfare"
                  href="javascript:;"
                >
                  <i v-if="firstNoClick"></i>
                </a>
                <div class="no_time-container" v-else>
                  <a
                    @click="openPayDialog(3)"
                    :class="btnClasses.notTime"
                    href="javascript:;"
                  ></a>
                  <p :class="btnClasses.bottomText">
                    福利礼包还剩{{ compCountdown }}解锁！
                  </p>
                </div>

                <!-- 未购买时显示的：周年款 / 典藏款 -->
                <template v-if="is_pay === 0">
                  <a
                    @click="openPayDialog(1)"
                    :class="btnClasses.anniversary"
                    href="javascript:;"
                  >
                    <i v-if="secondNoClick"></i>
                  </a>
                  <a
                    v-if="rewardPanelType === 3"
                    @click="openPayDialog(2)"
                    class="collection-btn"
                    href="javascript:;"
                  >
                    <i v-if="thirdNoClick"></i>
                  </a>
                </template>

                <!-- 购买后显示的：地址/收件信息 -->
                <template v-if="userInfo.role_id && is_pay > 0">
                  <a
                    v-if="!address && !end_address"
                    class="address-btn-anniversary"
                    href="javascript:;"
                    @click="openAddress"
                  ></a>
                  <a
                    v-if="address && !end_address"
                    class="modify-btn"
                    href="javascript:;"
                    @click="openAddress"
                  ></a>
                  <p v-if="address && !end_address" class="time-text">
                    剩余时间 {{ formattedTime }}
                  </p>
                  <a
                    v-if="end_address"
                    class="look-btn"
                    href="javascript:;"
                    @click="openAddress"
                  ></a>
                </template>
              </div>
            </div>

            <div class="bottom-item"></div>
          </div>

          <div class="swiper-slide foot-page">
            <Footer :gameName="gameName" />
          </div>
        </div>
      </div>
    </div>

    <Header
      :isOnline="1"
      :config="headerConfig"
      @downloadMonitor="downloadApp"
    />
    <!-- <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" /> -->
    <!-- 登录弹窗 -->
    <Login
      v-if="isShowLogin"
      v-on:channelCallback="selectCallback"
      :gameName="gameName"
      :loginTypes="loginTypes"
      :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"
      noAuthLogin
    ></Login>
    <Os
      v-if="isShowOs"
      v-on:selectCallback="selectCallback"
      v-on:logoutCallback="osCancell"
      :gameName="gameName"
    ></Os>

    <!-- 规则弹窗 -->
    <div
      :class="['rule-wrap popup_wrap', `rule-wrap-${ruleShow}`]"
      v-show="ruleShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="rule-box popup_wrap-box" v-show="ruleShow">
          <div class="rule_text_out">
            <img class="rule_text" :src="ruleSrc" />
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="ruleShow = false"></div>
    </div>

    <!-- 贵重品弹窗 -->
    <div
      :class="['expensive-wrap popup_wrap', `expensive-wrap-${expensiveShow}`]"
      v-show="expensiveShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="expensive-box popup_wrap-box" v-show="expensiveShow"></div>
      </transition>
      <div class="close-bg" @click="expensiveShow = false"></div>
    </div>

    <!-- 图片预览弹窗 -->
    <div
      :class="['preview-wrap', `preview-wrap-${previewShow}`]"
      v-show="previewShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="preview-box" v-show="previewShow">
          <img :src="nowImg" />
        </div>
      </transition>
      <div class="close-bg" @click="previewShow = false"></div>
    </div>

    <!-- 福利礼包弹窗 -->
    <div
      :class="['welfare-wrap popup_wrap', `welfare-wrap-${welfareShow}`]"
      v-show="welfareShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="welfare-box popup_wrap-box" v-show="welfareShow">
          <div class="get-btn-box">
            <a
              @click="getReward"
              v-if="!canBuy || !reawrd_status"
              class="get-btn"
              href="javascript:;"
            ></a>
            <a
              @click="reReward"
              v-if="canBuy && reawrd_status"
              class="not-get-btn"
              href="javascript:;"
            ></a>
          </div>
          <div class="reward-list-wrapper">
            <div class="list-content">
              <div
                :class="['list-item', i]"
                v-for="(i, index) in welfareStyle"
                :key="index"
              ></div>
            </div>
          </div>
          <div v-if="!canBuy" class="end-tip-text">
            <p>福利礼包还剩{{ compCountdown }}解锁！</p>
          </div>
        </div>
      </transition>

      <div class="close-bg" @click="welfareShow = false"></div>
    </div>

    <!-- 购买纪念章弹窗 -->
    <div
      :class="[
        'anniversary-wrap popup_wrap',
        `aniniversary-wrap-${buyAnniversaryShow}`,
      ]"
      v-show="buyAnniversaryShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="anniversary-box popup_wrap-box" v-show="buyAnniversaryShow">
          <div :class="anniversaryTitleClass"></div>
          <div class="anniversary-item">
            <div :class="anniversaryDescClass"></div>
          </div>
          <!-- 奖励列表预览 -->
          <div class="reward-list-wrapper">
            <div class="list-content-wrapper">
              <div class="list-content">
                <div
                  @click="isExpensiveItem(i)"
                  :class="['list-item', i]"
                  v-for="(i, index) in rewardShowList"
                  :key="index"
                ></div>
              </div>
            </div>
          </div>
          <!-- 付费购买周年/典藏礼包后，再次点击礼包，依然出现奖励介绍弹窗，但此时不出现支付按钮，顶部标题文案变为“周年版/典藏版纪念章” -->
          <div v-if="is_pay === 0 && canBuy" class="bottom-container">
            <div class="bottom-box">
              <div @click="goToPay('wechat')" class="wechat-btn"></div>
              <div @click="goToPay('alipay')" class="zfb-btn"></div>
            </div>
          </div>
          <div v-if="canBuy" class="quality-text"></div>
          <div v-if="!canBuy" class="end-tip-text">
            <p>奖章礼包还剩{{ compCountdown }}解锁！</p>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="closeAnniversary"></div>
    </div>

    <!-- 地址信息弹窗 -->
    <div
      :class="[
        is_pay == 1 ? 'znk-address-wrap' : 'dck-address-wrap',
        'popup_wrap',
      ]"
      v-show="addressShow"
    >
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
        :duration="{ enter: 1000 }"
      >
        <div class="address-box popup_wrap-box" v-show="addressShow">
          <!-- 动态渲染 姓名/电话/城市 输入框 -->
          <div
            v-for="field in addressFields"
            :key="field.key"
            :class="field.class"
          >
            <label>
              <input
                :type="field.type"
                v-model.trim="$data[field.key]"
                :disabled="end_address"
                :maxlength="field.maxlength"
                @focus="
                  field.key === 'selected' && !end_address
                    ? (showArea = true)
                    : null
                "
                :readonly="field.readonly"
              />
            </label>
          </div>

          <div
            class="city-box"
            @click="!end_address && (showArea = true)"
          ></div>

          <div class="address_class">
            <label>
              <textarea
                v-model.trim="address"
                :disabled="end_address"
              ></textarea>
            </label>
          </div>
          <div class="delivery_class">
            <label>
              <input
                disabled
                type="text"
                :value="odd_number || no_add_number"
              />
            </label>
          </div>
          <div
            id="odd_number"
            @click="handleCopy('#odd_number', '复制成功')"
            :data-clipboard-text="odd_number"
            class="clipboard_class"
          ></div>
          <!-- 单号存在 或者禁止填写了 隐藏掉 -->
          <div v-if="!end_address" class="affirm" @click="submitInfo"></div>
        </div>
      </transition>
      <div class="close-bg" @click="addressShow = false"></div>
    </div>

    <van-popup v-model="showArea" position="bottom" round class="custom-popup">
      <van-area
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>

    <!-- 支付提示-弹窗 -->
    <div class="payment_tips_page popup_wrap" v-show="paymentTipsShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="payment_tips_box" v-show="paymentTipsShow">
          <h2>提示</h2>
          <p>请确认是否完成支付</p>
          <div>
            <a @click="orderQuery(1)" href="javascript:;">已完成支付</a>
            <a @click="orderQuery(2)" href="javascript:;">未完成支付</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- webview内的微信支付提示-弹窗 -->
    <div class="web_tips_page popup_wrap" v-show="payTipShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="web_tips_box" v-show="payTipShow">
          <h2>支付提示</h2>
          <div class="tip-text">
            <p>
              微信暂时无法支付，推荐使用支付宝！<br />
              <span class="highlight">
                （可复制链接使用浏览器，进行微信支付）
              </span>
            </p>
          </div>
          <div>
            <a class="cancel" @click="payTipShow = false" href="javascript:;"
              >取消</a
            >
            <a
              id="url_link"
              @click="handleCopy('#url_link', '复制成功，请前往浏览器')"
              :data-clipboard-text="url_link"
              href="javascript:;"
              >复制链接</a
            >
          </div>
        </div>
      </transition>
    </div>

    <!-- 上一笔订单未支付提示-弹窗 -->
    <div class="payment_tips_page popup_wrap" v-show="fePaymentTipsShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="payment_tips_box" v-show="fePaymentTipsShow">
          <h2>提示</h2>
          <p>您有一笔订单是否继续支付</p>
          <div>
            <a @click="cancelOrder" href="javascript:;">关闭取消支付</a>
            <a @click="goOnPay" href="javascript:;">继续前往支付</a>
          </div>
        </div>
      </transition>
    </div>

    <!-- 付款失败-弹窗 -->
    <div class="payment-failed-wrap popup_wrap" v-show="paymentFailedShow">
      <transition
        enter-active-class="animated zoomInNew"
        leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }"
      >
        <div class="popup-wrap-box" v-show="paymentFailedShow">
          <div class="btn-box-sure">
            <a href="javascript:;" @click="payFail">确定</a>
          </div>
        </div>
      </transition>
      <div class="close-bg" @click="paymentFailedShow = false"></div>
    </div>

    <!-- 微信里的支付宝引导 -->
    <div class="wx_download_wrap popup_wrap" v-show="zfbShow">
      <transition
        enter-active-class="animated fadeIn"
        leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }"
      >
        <div class="wx_download_wrap_content" @click="zfbShow = false"></div>
      </transition>
      <div class="close-bg" v-if="zfbShow" @click="zfbShow = false"></div>
    </div>

    <div class="content-01" :style="'visibility: ' + showVideo">
      <canvas id="canvas" width="100%" height="100%"></canvas>
    </div>

    <!-- 支付宝调用标签 -->
    <div id="aliPayBtn"></div>

    <!-- 阻止点击弹出-弹窗 -->
    <div
      @touchmove.prevent
      :class="['prevent-wrap', `prevent-wrap-${preventShow}`]"
    ></div>
  </div>
</template>
<script>
// 按需引入 vant 组件
import { Popup, Area } from "vant";
import { areaList } from "@vant/area-data";
import { Toast, Indicator } from "mint-ui";
import { mapState, mapMutations, mapActions } from "vuex";
import Os from "@/components/os";
import Login from "@/components/login";
import Header from "../Header/index.vue";
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";
import Clipboard from "clipboard";
import {
  hasActualQuality,
  onGetInitDataAPI,
  getRewardApi,
  modifyAddressApi,
  craeteOrderApi,
  checkOrderAPI,
  wechatInfoAPI,
  orderOff,
  downloadApps,
} from "../api";
import {
  getTimeStamp,
  wechatBrowser,
  buriedLogger,
  getRandomString,
  analysisParams,
} from "@/utils/utils";
import "../jsmpeg";

const commonConfig = {
  resistanceRatio: 0,
  mousewheelControl: true,
  speed: 500,
  parallax: true,
  slidesPerView: "auto",
  lazyLoading: true,
  lazyLoadingInPrevNext: true,
  preloadImages: false,
  observer: true,
  observeParents: true,
};

const PAY_STATUS = {
  UNPAID: 0,
  ANNIVERSARY_EDITION: 1, // 周年款
  COLLECTOR_EDITION: 2, // 典藏款
};

// 统一配置请求参数中的期数
const CURRENT_PERIOD = 3;

export default {
  name: "anniversary",
  components: {
    Header,
    Footer,
    Login,
    Os,
    [Popup.name]: Popup,
    [Area.name]: Area,
  },
  data() {
    return {
      url_link: "",
      payTipShow: false,
      remainingSeconds: 0,
      timer1: null,
      end_time: "", // 有这个代表地址已经填写过一次了

      currentIndex: 0,

      provincial: "", // 省
      city: "", // 市
      area: "", // 区

      showArea: false,
      areaList,
      selected: "",

      showVideo: "hidden",
      isWhite: "",
      ruleSrc:
        "https://download4.qcplay.com/qcgame-api/JNKziVrcr2k92GdStJGsoih1OZFitORPGO69tKpT.png",
      swiperList: [
        {
          photo:
            "https://download4.qcplay.com/qcgame-api/DC3QA1mkrWOEizpCTT2hXSX0jsnetzAOUaX9o3Q6.png",
        },
        {
          photo:
            "https://download4.qcplay.com/qcgame-api/sizohZOsRdabtPZUkek21wWDSDJa2Bz8sUlL6Jf2.png",
        },
      ],
      reawrd_status: false, // 未领取过
      end_address: false, // 是否结束填写地址
      old_order: null, // 未支付的订单
      rewardShowList: [], // 弹窗展示的奖励
      zfbShow: false,
      no_add_number: "未发货",
      odd_number: "",
      // 提交信息的数据
      name: "", // 收件人
      phone: "", // 手机号
      address: "", // 收货地址
      is_pay: 0, // 0: 还没买 1: 周年款 2: 典藏款
      firstNoClick: true, // 默认玩家没点击过第一个礼包的
      secondNoClick: true, // 默认玩家没点击过第二个礼包的
      thirdNoClick: true, // 默认玩家没点击过第三个礼包的
      welfareShow: false,
      canBuy: true, // 是否发售
      timer: null, // 定时器
      compCountdown: "",
      countdown: "",
      buyType: "", // 购买的是哪一个  1: 周年款 2: 典藏款 3: 普通福利
      collectionStyle: ["dck-gzp", "avatar-a", "bkd-1000", "cjq-20", "jnz-50"], // 典藏款
      anniversaryStyle: ["znk-gzp", "avatar-b", "bkd-600", "cjq-10", "jnz-30"], // 周年款
      welfareStyle: ["bkd-300", "cjq-5", "jnz-10"],
      nowImg: "", // 当前预览的是哪一张图
      buyAnniversaryShow: false, // 纪念窗弹窗
      expensiveShow: false, // 贵重品弹窗
      previewShow: false, // 预览图片弹窗
      addressShow: false, // 地址信息弹窗
      headerConfig,
      gameName: "snail",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: "http://snail.qingcigame.com/official/",
      downloadUrls: {
        android_url: "https://download4.qcplay.com/apk-v2/qc-kol-1164305.apk",
        ios_url:
          "https://apps.apple.com/cn/app/%E6%9C%80%E5%BC%BA%E8%9C%97%E7%89%9B/id1507966188",
      },
      preloadingShow: false,
      preventShow: false,
      ruleShow: false,
      actual_quantity: false, // 是否还有典藏款
      paymentTipsShow: false,
      fePaymentTipsShow: false, // 上一笔没支付成功
      isWechatBrowser: false, // 是否为微信浏览器
      // 支付选择类型
      my_payment_select: 0, // 0支付宝  1是微信
      // 当前支付类型
      paymentData: "",
      // open_id微信支付用
      open_id: "",
      // 2种支付方式
      paymentList: [
        {
          icon: "zfb",
          name: "支付宝支付",
          select: "1",
          payType: "alipay",
          payMethod: "wap",
        },
        {
          icon: "wx",
          name: "微信支付",
          select: "0",
          payType: "wechat",
          payMethod: "mp",
        },
      ],
      // 单独微信支付方式
      paymentList3: [
        {
          icon: "wx",
          name: "微信支付",
          select: "1",
          payType: "wechat",
          payMethod: "mp",
        },
      ],
      paymentFailedShow: false, // 支付失败 弹窗
    };
  },
  created() {
    window.addEventListener("pageshow", this.resize);
    window.addEventListener("resize", this.resize);
    this.isWechatBrowser = wechatBrowser();
    const params = analysisParams(window.location.href);
    const { download_id } = params;

    download_id &&
      downloadApps({ download_id, title: "title" }).then((res) => {
        if (res.code === 200) {
          this.downloadUrls = res.data;
        }
      });
    hasActualQuality().then((response) => {
      if (Number(response.code) === 200) {
        this.actual_quantity = response.data.actual_quantity;
      } else {
        this.onToast(response.message);
      }
    });
    // 微信app内，需要获取openid才能做微信支付
    if (this.isWechatBrowser) {
      wechatInfoAPI({ periods: CURRENT_PERIOD }).then((response) => {
        if (Number(response.code) === 200) {
          this.open_id = response.data.open_id;
          if (response.data.open_id == null) {
            window.location.href =
              "//api.qingcigame.com/wechat/get/open/?back=" +
              encodeURIComponent(window.location.href);
            return;
          }
          this.getLoginContainer();
        } else {
          this.getLoginContainer();
          this.onToast(response.message);
        }
      });
    }
    this.getLoginContainer();
  },
  mounted() {
    this.$nextTick(() => {
      const { protocol, host } = window.location;
      const enterLink = `${protocol}//${host}/snail/sixAnniversary/enter${getRandomString()}`;
      const pcLink = `${protocol}//${host}/snail/sixAnniversary/pc`;
      this.url_link = window.location.origin + window.location.pathname;
      this.monitoringEquipmentPc(pcLink);
      this.isSetShare(enterLink);

      this.anniverSarySwiper(); // 首页初始化
      // this.hlwSwiper2(); // 纪念章轮播初始化
      // 埋点
      const bl = buriedLogger("snail", "蜗牛_六周年_纪念章h5");
      this.logger = bl;
      setTimeout(() => {
        this.logger.sum("蜗牛_六周年_纪念章h5_活动页统计");
      }, 200);
    });
  },
  methods: {
    goAnniversary() {
      window.location.href = "https://qcg.ink/WqJ823";
    },
    initCountdown() {
      if (!this.end_time) return;

      // 兼容 iOS：时间格式中 - 替换为 /
      const baseTime = new Date(this.end_time.replace(/-/g, "/"));
      const targetTime = new Date(baseTime.getTime() + 48 * 60 * 60 * 1000); // +48小时
      const now = new Date();
      const diff = Math.floor((targetTime - now) / 1000);
      this.remainingSeconds = diff > 0 ? diff : 0;

      // 启动倒计时
      this.timer1 = setInterval(() => {
        if (this.remainingSeconds > 0) {
          this.remainingSeconds--;
        } else {
          clearInterval(this.timer);
          this.timer1 = null;
        }
      }, 1000);
    },

    // ✅ 单按钮切换逻辑（循环播放）
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.swiperList.length;
    },

    onConfirm(e) {
      // province: '', // xx省
      // sq: '', // xx市
      // qu: '', // xx区
      this.provincial = e[0].name;
      this.city = e[1].name;
      this.area = e[2].name;

      this.selected = e[0].name + " " + e[1].name + " " + e[2].name;
      this.showArea = false;
    },

    monitoringEquipmentPc(pcLink) {
      if (!/(iPhone|iPod|mobile|Android|ios)/i.test(navigator.userAgent))
        location.href = pcLink;
    },
    downloadApp() {
      if (this.isWechatBrowser) {
        this.zfbShow = true;
        return;
      }

      const linkObj = this.downloadUrls || {};

      const isIOS = navigator.userAgent.match(/(iPhone|iPod|ios)/i);
      const targetLink = isIOS ? linkObj.ios_url : linkObj.android_url;

      this.logger && this.logger.sum("蜗牛_六周年_纪念章h5_【下载】跳转按钮");

      if (targetLink) {
        setTimeout(() => {
          window.location.href = targetLink;
        }, 200);
      }
    },
    resize() {
      // 兼容宽屏
      if (window.innerWidth / window.innerHeight > 320 / 470) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.75)";
          });
      } else if (window.innerWidth / window.innerHeight > 320 / 520) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.85)";
          });
      } else if (window.innerWidth / window.innerHeight > 320 / 560) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.9)";
          });
      } else if (window.innerWidth / window.innerHeight > 320 / 620) {
        document
          .querySelectorAll(".popup_wrap .popup_wrap-box")
          .forEach((item) => {
            item.style.transform = "scale(0.95)";
          });
      }
    },
    video() {
      let canvas = document.getElementById("canvas");
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      let url = "https://download4.qcplay.com/snail/out/out.ts";
      let player = new window.$JSMpeg.Player(url, {
        canvas: canvas,
        loop: false,
        autoplay: true,
        audio: false,
        progressive: false,
        onSourceCompleted: (player) => {
          this.showVideo = "visible";
          this.preloadingShow = false;
        },
        onEnded: (player) => {
          this.showVideo = "hidden";
          localStorage.setItem("lookedVideo", 1);
        },
      });
      player.play();
    },
    openAddress() {
      this.getLoginContainer();
      this.addressShow = true;
      this.logger.sum("蜗牛_六周年_纪念章h5_点击收货地址按钮");
    },
    payFail() {
      this.paymentFailedShow = false;
      this.getLoginContainer();
      this.logger.sum("蜗牛_六周年_纪念章h5_点击支付失败的确定按钮");
    },
    cancelOrder() {
      orderOff({ periods: CURRENT_PERIOD })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.fePaymentTipsShow = false;
            this.getLoginContainer();
          }
          this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
      this.logger.sum("蜗牛_六周年_纪念章h5_取消支付按钮");
    },
    reReward() {
      this.onToast("很抱歉,您已经领取过");
    },
    goOnPay() {
      window.location.href = this.old_order;
      setTimeout(() => {
        this.preventShow = false;
      }, 1000);
      this.logger.sum("蜗牛_六周年_纪念章h5_点击支付上一笔订单的按钮");
    },
    // 立即支付
    goToPay(payType) {
      if (payType == "wechat") {
        const { ua } = analysisParams(window.location.href);
        if (ua == "snail") {
          this.payTipShow = true;
          return;
        }
      }
      // 微信内的支付宝支付还是让他跑外面去付
      // 微信内的微信支付一直都是最新的 支付宝的话会弹出引导
      // 监测是否微信 (是为mp，否则map)
      if (this.paymentList.length > 1) {
        this.paymentList[1].payMethod = this.isWechatBrowser ? "mp" : "wap";
      }
      if (this.isWechatBrowser && payType == "alipay") {
        // 在微信app下点的是支付宝支付
        this.preventShow = false;
        this.zfbShow = true;
        return;
      }
      const type = this.buyType === 1 || this.buyType === 3 ? 0 : 1;
      // 0 是支付宝 1是微信
      if (this.paymentList.length > 1) {
        payType == "wechat"
          ? (this.my_payment_select = 1)
          : (this.my_payment_select = 0);
        for (var i = 0; i <= this.paymentList.length - 1; i++)
          this.paymentList[i].select = 0;
        this.paymentList[this.my_payment_select].select = 1;
        this.paymentData = this.paymentList[this.my_payment_select];
      } else {
        // 微信内只有一种
        this.paymentData = this.paymentList3[0];
      }
      this.preventShow = true;
      // 微信外的支付
      if (!this.isWechatBrowser && this.old_order) {
        this.fePaymentTipsShow = true;
        setTimeout(() => {
          this.preventShow = false;
        }, 500);
        return;
      }
      craeteOrderApi({
        pay_type: this.paymentData.payType,
        pay_method: this.paymentData.payMethod,
        open_id: this.open_id,
        type,
        periods: CURRENT_PERIOD,
      }).then((response) => {
        if (response.message == "很抱歉,典藏款已被抢完~") {
          this.onToast(response.message, 2000);
          this.buyAnniversaryShow = false;
          this.getLoginContainer(); // 初始化一次
          setTimeout(() => {
            this.preventShow = false;
          }, 500);
          return;
        }
        if (Number(response.code) == 200) {
          // 只有支付宝支付才要判断
          // 微信内的微信内支付没有
          // 微信内的支付宝支付还是让他跑外面去付
          // 支付订单存储
          this.order = response.data.order;
          this.paymentTipsShow = true;
          // 移动端
          if (/(iPhone|iPod|Android|ios)/i.test(navigator.userAgent)) {
            // 微信发送支付
            if (this.paymentData.payType == "wechat") {
              // 外部浏览器调用
              if (this.paymentData.payMethod == "mp") {
                // wx.ready(() => {
                wx.chooseWXPay({
                  timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                  nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: response.data.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                  paySign: response.data.data.paySign, // 支付签名
                  success: function (res) {
                    // 支付成功后的回调函数
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  },
                  fail: function (res) {
                    setTimeout(() => {
                      this.preventShow = false;
                    }, 1000);
                  },
                });
                // })
                setTimeout(() => {
                  this.preventShow = false;
                }, 2000);
              } else {
                if (response.data.data !== "") {
                  window.location.href = response.data.data;
                  setTimeout(() => {
                    this.preventShow = false;
                  }, 1000);
                }
              }
            } else if (response.data.data !== "") {
              document.getElementById("aliPayBtn").innerHTML =
                response.data.data;
              document.forms["alipaysubmit"].submit();
              // window.location.href = response.data.data;
              setTimeout(() => {
                this.preventShow = false;
              }, 1000);
            }
          }
          return;
        }
        this.onToast(response.message, 2000);
        setTimeout(() => {
          this.preventShow = false;
        }, 500);
        this.logger.sum("蜗牛_六周年_纪念章h5_点击购买按钮");
      });
    },
    timeFormatted(str) {
      // 计算小时
      const hours = Math.floor(str / 3600);
      // 计算分钟
      const minutes = Math.floor((str % 3600) / 60);
      // 计算秒
      const seconds = str % 60;
      // 格式化为 h:m:s，确保每个单位至少有两位数字
      return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    // 统一复制逻辑
    handleCopy(my_id, successMsg) {
      const clipboard = new Clipboard(my_id);
      clipboard.on("success", (e) => {
        this.onToast(successMsg, 1000);
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.onToast("复制失败", 1000);
      });
    },
    orderQuery(type) {
      this.paymentTipsShow = false;
      // 订单轮询
      type == 1 ? (this.wait = 15) : (this.wait = 2);
      this.orderLoop(type);
      this.logger.sum(`订单轮询_${type === 1 ? "已完成订单" : "未完成订单"}`);
    },
    // 订单轮询
    orderLoop(i) {
      if (this.wait > 0) {
        this.onPayment(i);
        this.wait--;
        this.preventShow = true;
        Indicator.open();
        setTimeout(() => {
          this.orderLoop(i);
        }, 1500);
      } else {
        this.preventShow = false;
      }
    },
    onPayment(i) {
      checkOrderAPI({ trade_no: this.order, periods: CURRENT_PERIOD }).then(
        (response) => {
          if (Number(response.code) === 200) {
            // 支付成功
            this.wait = 0;
            if (i == 1) this.onToast(response.message, 2000);
            this.getSuccessPayContainer();
            this.buyAnniversaryShow = false;
            this.preventShow = false;
            Indicator.close();
            return;
          }
          if (Number(response.code) != 200) {
            if (this.wait == 0) {
              if (i == 1) this.onToast(response.message, 2000);
              this.paymentFailedShow = true;
              Indicator.close();
            }
          }
        }
      );
    },
    closeAnniversary() {
      this.buyAnniversaryShow = false;
    },
    validateAddress(address) {
      const value = String(address || "").trim();

      if (!value) {
        this.onToast("详细收货地址不能为空");
        return false;
      }

      // 不能是纯数字
      if (/^\d+$/.test(value)) {
        this.onToast("详细地址不能为纯数字");
        return false;
      }

      if (value.length < 5) {
        this.onToast("详细地址不能少于5个字");
        return false;
      }

      if (value.length > 80) {
        this.onToast("详细地址不能超过80个字");
        return false;
      }

      // 不能全是符号
      if (!/[\u4e00-\u9fa5a-zA-Z0-9]/.test(value)) {
        this.onToast("详细地址格式不正确");
        return false;
      }

      /**
       * 重点：
       * 必须包含至少一个中文或英文字母。
       * 这样可以拦截：
       * 123-456
       * 1-2-301
       * #301
       * 88-2-101
       */
      if (!/[\u4e00-\u9fa5a-zA-Z]/.test(value)) {
        this.onToast("详细地址需包含街道、小区、楼栋或门牌等信息");
        return false;
      }

      // 禁止 emoji
      if (/[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(value)) {
        this.onToast("详细地址不能包含表情符号");
        return false;
      }

      // 禁止高风险特殊字符
      if (/[<>"'`\\&|]/.test(value)) {
        this.onToast("详细地址不能包含特殊字符");
        return false;
      }

      /**
       * 允许：
       * 中文、英文、数字、空格
       * 常见地址符号：- # _ / 、 ， , 。 . ： : ； ; （ ） ( )
       */
      const addressReg =
        /^[\u4e00-\u9fa5a-zA-Z0-9\s\-#_/、，,。.：:；;（）()]+$/;

      if (!addressReg.test(value)) {
        this.onToast("详细地址格式不正确，请勿输入特殊符号");
        return false;
      }

      return true;
    },
    // 提交信息接口请求
    submitInfo() {
      const filterSpaces = (str) => {
        return str.replace(/\s/g, "");
      };
      // 如果已经发货的提示也不请求了
      if (this.odd_number !== 0 && this.odd_number !== "") {
        this.onToast("已成功发货，可复制单号查询物流！");
        return;
      }

      let params = {
        name: filterSpaces(this.name),
        phone: filterSpaces(this.phone),
        address: String(this.address || "").trim(),
        provincial: this.provincial, // 省
        city: this.city, // 市
        area: this.area, // 区
        periods: CURRENT_PERIOD,
      };

      if (!params.name) {
        this.onToast("收件人姓名不能为空");
        return;
      }

      // 手机号正则校验
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(params.phone)) {
        this.onToast("请输入有效的手机号码");
        return;
      }

      if (!params.provincial || !params.city || !params.area) {
        this.onToast("省市区不能为空");
        return;
      }

      if (!this.validateAddress(params.address)) {
        return;
      }

      modifyAddressApi(params).then((res) => {
        if (res.code === 200) {
          // this.isWriteShow = false
          // this.isSuccessShow = true
          // // 成功后调用初始化数据
          // this.initData()
          this.getLoginContainer();
          this.addressShow = false;
          this.onToast(res.message);
        } else {
          if (res.message == "很抱歉,请求参数不正确") {
            this.onToast("尚未完成地址填写");
            return;
          }
          this.onToast(res.message);
        }
        this.logger.sum("蜗牛_六周年_纪念章h5_点击确认收货地址的按钮");
      });
    },
    // 领取福利礼包
    getReward() {
      if (!this.canBuy) {
        this.onToast("还未到领取时间");
        return;
      }
      getRewardApi({ periods: CURRENT_PERIOD })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.welfareShow = false;
            this.getLoginContainer();
            this.logger.sum("蜗牛_六周年_纪念章h5_点击领取福利礼包的按钮");
          }
          this.onToast(response.message);
        })
        .catch(() => {
          this.onToast("服务器出错啦");
        });
    },
    // 判断是不是贵重品
    isExpensiveItem(itemName) {
      if (["dck-gzp", "znk-gzp"].includes(itemName)) {
        this.expensiveShow = true;
        this.logger.sum("蜗牛_六周年_纪念章h5_点击贵重品");
      }
    },
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          // 每次减少1秒
          this.countdown--;
          this.compCountdown = this.timeFormatted(this.countdown);
        } else {
          // 倒计时结束，清除定时器
          this.canBuy = true;
          clearInterval(this.timer);
        }
      }, 1000); // 每1000毫秒更新一次
    },
    showImage(src) {
      this.nowImg = src;
      this.previewShow = true;
      this.logger.sum("蜗牛_六周年_纪念章h5_点击查看大图");
    },
    openPayDialog(buyType) {
      if (!this.userInfo.role_id) {
        this.changeLoginPopup(true);
        return false;
      }
      if (buyType === 1) {
        // 周年
        this.setClickStatus("secondClick", false);
        this.secondNoClick = false;
        this.buyType = buyType;
        this.buyAnniversaryShow = true;
        this.rewardShowList = this.anniversaryStyle;
      } else if (buyType === 2) {
        // 典藏
        this.setClickStatus("thirdClick", false);
        this.buyType = buyType;
        this.thirdNoClick = false;
        this.buyAnniversaryShow = true;
        this.rewardShowList = this.collectionStyle;
      } else {
        this.setClickStatus("firstClick", false);
        // 福利礼包
        this.firstNoClick = false;
        this.welfareShow = true;
      }
      // 买过了
      if (this.is_pay) {
        if (this.buyType === 1) {
          this.buyType = 3;
        } else {
          this.buyType = 4;
        }
      }
      this.logger.sum("蜗牛_六周年_纪念章h5_查看对应礼包的按钮");
    },
    // 初始化swiper
    anniverSarySwiper() {
      new Swiper(".swiper-container", {
        ...commonConfig,
        direction: "vertical",
      });
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: "《最强蜗牛》六周年纪念奖章",
        imgUrl:
          "https://download4.qcplay.com/qcgame-api/2Ce8vtl2wY6u701UompVaplTHG3iWdoeYz2KVHSq.png",
        desc: "六周年限定纪念奖章强势来袭！周年专属，错过再等一年！",
      });
    },
    // 获取用户信息
    getSuccessPayContainer() {
      onGetInitDataAPI({ periods: CURRENT_PERIOD })
        .then((response) => {
          this.isWhite = Number(response.code) !== 403;
          if (Number(response.code) === 200) {
            this.actual_quantity = response.data.activity.actual_quantity; // 是否还有典藏款
            this.odd_number = response.data.activity.odd_number; // 是否发货了
            this.is_pay = response.data.activity.is_pay; // 是否购买了 0 1 2
            this.name = response.data.activity.name;
            this.phone = response.data.activity.phone;
            this.address = response.data.activity.address;
            this.countdown = response.data.activity.countdown;
            this.end_address = response.data.activity.end_address;
            this.reawrd_status = response.data.activity.reawrd_status;
            this.old_order = response.data.activity.old_order;
            this.compCountdown = this.timeFormatted(this.countdown);
            this.startCountdown();
            this.initCountdown();
            this.onInitDataCallback(response);
            if (this.countdown > 0) {
              this.canBuy = false;
            }
            if (this.is_pay == 1 || this.is_pay == 2) {
              this.addressShow = true;
            }
            return;
          }
          Number(response.code) !== 401 && this.onToast(response.message);
        })
        .catch((err) => {
          this.onToast("服务器出错啦");
        });
    },
    async getLoginContainer() {
      if (localStorage.getItem("lookedVideo")) {
        setTimeout(() => {
          this.preloadingShow = false;
        }, 1000);
      } else {
        this.preloadingShow = true;
      }
      await onGetInitDataAPI({ periods: CURRENT_PERIOD })
        .then((response) => {
          if (Number(response.code) === 200) {
            this.actual_quantity =
              (response.data.activity &&
                response.data.activity.actual_quantity) ||
              false; // 是否还有典藏款
            this.odd_number =
              (response.data.activity && response.data.activity.odd_number) ||
              ""; // 是否发货了
            this.is_pay =
              (response.data.activity && response.data.activity.is_pay) ||
              PAY_STATUS.UNPAID; // 是否购买了 0 1 2
            this.name =
              (response.data.activity && response.data.activity.name) || "";
            this.phone =
              (response.data.activity && response.data.activity.phone) || "";
            this.address =
              (response.data.activity && response.data.activity.address) || "";
            this.countdown =
              (response.data.activity && response.data.activity.countdown) || 0;
            this.end_address =
              (response.data.activity && response.data.activity.end_address) ||
              false;
            this.reawrd_status =
              (response.data.activity &&
                response.data.activity.reawrd_status) ||
              false;
            this.old_order =
              (response.data.activity && response.data.activity.old_order) ||
              null;
            this.end_time =
              (response.data.activity && response.data.activity.end_time) || "";

            this.area =
              (response.data.activity && response.data.activity.area) || "";
            this.city =
              (response.data.activity && response.data.activity.city) || "";
            this.provincial =
              (response.data.activity && response.data.activity.provincial) ||
              "";

            this.selected = this.provincial + " " + this.city + " " + this.area;
            if (this.countdown > 0) {
              this.canBuy = false;
            }
            this.compCountdown = this.timeFormatted(this.countdown);
            if (this.timer) clearInterval(this.timer);
            if (this.timer1) clearInterval(this.timer1);
            this.initCountdown();
            this.startCountdown();
            this.onInitDataCallback(response);

            // 数据初始化完成后，重新计算一次红点状态
            this.firstNoClick = this.getClickStatus("firstClick");
            this.secondNoClick = this.getClickStatus("secondClick");
            this.thirdNoClick = this.getClickStatus("thirdClick");
            // return;
          }
          this.isWhite = Number(response.code) !== 403;
          if (Number(response.code) != 403) {
            setTimeout(() => {
              if (localStorage.getItem("lookedVideo")) {
                // 看过视频了就直接进入
                this.showVideo = "hidden";
              } else {
                // 没看过视频
                this.$nextTick(() => {
                  this.video();
                });
              }
            }, 1001);
          }
          if (response.message != "ok") {
            Number(response.code) !== 401 && this.onToast(response.message);
          }
        })
        .catch((err) => {
          this.onToast("服务器出错啦");
        });
      setTimeout(() => {
        this.preloadingShow = false;
      }, 5000);
    },
    // 清除data里面相关数据
    clearActiveInfo() {
      this.firstNoClick = true;
      this.secondNoClick = true;
      this.thirdNoClick = true;
      this.odd_number = "";
      this.actual_quantity = true;
      this.is_pay = 0;
      this.canBuy = true;
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (this.timer1) {
        clearInterval(this.timer1);
      }
      hasActualQuality({ periods: CURRENT_PERIOD }).then((response) => {
        if (Number(response.code) === 200) {
          this.actual_quantity = response.data.actual_quantity;
        } else {
          this.onToast(response.message);
        }
      });
      this.getLoginContainer();
    },
    // 选择角色后
    selectCallback() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.getLoginContainer();
      console.log("userInfo：", this.userInfo);
      console.log("actual_quantity：", this.actual_quantity);
      // 使用通用函数为三个状态赋值
      this.firstNoClick = this.getClickStatus("firstClick");
      this.secondNoClick = this.getClickStatus("secondClick");
      this.thirdNoClick = this.getClickStatus("thirdClick");
    },
    setClickStatus(keySuffix, status) {
      const roleName =
        this.userInfo && this.userInfo.role_name
          ? this.userInfo.role_name
          : "guest";
      window.localStorage.setItem(
        `${roleName}_${keySuffix}`,
        JSON.stringify(status)
      );
    },
    getClickStatus(keySuffix) {
      const roleName =
        this.userInfo && this.userInfo.role_name
          ? this.userInfo.role_name
          : "guest";
      const storedValue = window.localStorage.getItem(
        `${roleName}_${keySuffix}`
      );
      return this.userInfo.role_name
        ? storedValue !== null
          ? JSON.parse(storedValue)
          : true
        : true;
    },
    // 注销
    osCancell() {
      this.clearActiveInfo();
    },
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: "toasts",
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setLogger",
    ]),
    ...mapActions(["onInitDataCallback", "setShare"]),
  },
  beforeDestroy() {
    window.removeEventListener("pageshow", this.resize);
    window.removeEventListener("resize", this.resize); // 必须解绑！

    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.timer1) {
      clearInterval(this.timer1);
    }
  },
  computed: {
    // 首页右侧标题动态样式
    rightTitleClass() {
      if (this.userInfo.role_id && this.is_pay === 1) return "right-title-4";
      if (this.userInfo.role_id && this.is_pay === 2) return "right-title-5";
      if (!this.canBuy && this.actual_quantity) return "right-title-1";
      if (this.canBuy && this.actual_quantity && this.is_pay === 0)
        return "right-title-2";
      if (this.canBuy && !this.actual_quantity && this.is_pay === 0)
        return "right-title-3";
      return "";
    },
    // 纪念章弹窗标题样式
    anniversaryTitleClass() {
      const typeMap = {
        1: "first-anniversary",
        2: "second-anniversary",
        3: "third-anniversary",
        4: "four-anniversary",
      };
      return typeMap[this.buyType] || "";
    },
    // 纪念章弹窗描述样式
    anniversaryDescClass() {
      if (this.buyType === 1 || this.buyType === 3) return "first-desc";
      if (this.buyType === 2 || this.buyType === 4) return "second-desc";
      return "";
    },
    // 地址弹窗输入框配置
    addressFields() {
      return [
        { key: "name", class: "name_class", type: "text" },
        { key: "phone", class: "phone_class", type: "number", maxlength: "11" },
        { key: "selected", class: "city_class", type: "text", readonly: true },
      ];
    },
    // 动态计算底部按钮的样式组合
    btnClasses() {
      if (this.userInfo.role_id && this.is_pay > 0) {
        return {
          welfare: "welfare-btn-uni",
          notTime: "not_time_btn",
          bottomText: "bottom-text",
        };
      }
      if (this.rewardPanelType === 3) {
        return {
          welfare: "welfare-btn",
          notTime: "not_time_btn-uni",
          bottomText: "bottom-text",
          anniversary: "anniversary-btn",
        };
      }
      return {
        welfare: "welfare-btn-no",
        notTime: "not_time_btn-no",
        bottomText: "bottom-text-no",
        anniversary: "anniversary-btn-no",
      };
    },
    // 根据库存和购买状态计算应该展示几个奖励容器 (2个或3个)
    rewardPanelType() {
      if (!this.actual_quantity) return 2; // 无库存
      if (this.is_pay === 1) return 3; // 无库存但买了周年款 (原逻辑是3个)
      return 3;
    },
    // 格式化为 47:59:59
    formattedTime() {
      const h = String(Math.floor(this.remainingSeconds / 3600)).padStart(
        2,
        "0"
      );
      const m = String(
        Math.floor((this.remainingSeconds % 3600) / 60)
      ).padStart(2, "0");
      const s = String(this.remainingSeconds % 60).padStart(2, "0");
      return `${h}:${m}:${s}`;
    },
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.osCancell();
        } else if (
          newValue.role_id !== oldValue.role_id ||
          newValue.account !== oldValue.account
        ) {
          this.firstNoClick = this.getClickStatus("firstClick");
          this.secondNoClick = this.getClickStatus("secondClick");
          this.thirdNoClick = this.getClickStatus("thirdClick");
          // 数据初始化
          // this.getLoginContainer();
          hasActualQuality().then((response) => {
            if (Number(response.code) === 200) {
              this.actual_quantity = response.data.actual_quantity;
            } else {
              this.onToast(response.message);
            }
          });
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");

/deep/ .custom-popup {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;

  // shadows if needed
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  // 强制白背景（避免被下面透出色）
  background: #fff;
}

/deep/ .van-area {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  overflow: hidden;
  background: #fff;
}

// 优化按钮字体
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  font-size: 30px !important;
}

// 内容行高字体调大
/deep/ .van-picker-column__item {
  font-size: 30px !important;
}

/deep/ .van-picker {
  min-height: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/snail/sixAnniversary/index/index.vue